import { FC } from "react";
import { Route, RouteComponentProps, Switch } from "react-router-dom";
import { RouteStatements } from "./routes/RouteStatements";

export const StatementIndex: FC<RouteComponentProps> = () => {
  return (
    <Switch>
      <Route path="/member/statements" component={RouteStatements} />
    </Switch>
  );
};
